const determineIconType = (type) => {
  const iconMap = {
    Video: 'play',
    Podcast: 'listen'
  }

  return iconMap[type]
}

export default determineIconType
